import { FormControlLabel, FormControlLabelProps, styled } from '@mui/material';

export const stylesCrossingInfoBannerFormRadio = {
  '.MuiFormControlLabel-root': {
    flex: 1,
    m: 0,
  },
};

export const stylesRadioBox = {
  position: 'relative',
};
export const RadioBoxIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 22,
  height: 22,
  backgroundColor: theme.palette.grey[300],
  '&.Mui-error': {
    borderColor: theme.palette.error.main,
  },
}));

export const RadioBoxCheckedIcon = styled(RadioBoxIcon)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  position: 'relative',
  '&:before': {
    display: 'block',
    width: 12,
    height: 12,
    backgroundColor: '#FFF',
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    content: '""',
  },
}));

export const StyledFormControlLabel = styled((props: FormControlLabelProps) => <FormControlLabel {...props} />)(
  ({ theme, checked }) => ({
    position: 'relative',
    margin: theme.spacing(0, 2, 0, 0),
    boxSizing: 'border-box',
    padding: theme.spacing(2, 4, 2, 3),
    borderRadius: theme.shape.borderRadius,
    flex: 1,
    '&:first-of-type': {
      marginRight: '0.5rem',
    },
    '&:last-of-type': {
      marginLeft: '0.5rem',
    },
    '&::before': {
      position: 'absolute',
      height: '100%',
      width: '100%',
      left: 0,
      zIndex: -1,
      border: `1px dashed ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      content: '""',
    },
    ...(checked && {
      '::before': {
        borderStyle: 'solid',
        borderColor: theme.palette.primary.main,
        background: theme.palette.primary.lighter,
      },
    }),
    '.Mui-focused + .MuiFormGroup-row  &::before': {
      borderWidth: 2,
    },
    '&.Mui-error::before': {
      borderColor: theme.palette.error.main,
    },
    '.MuiFormControlLabel-label.Mui-disabled': {
      zIndex: 1,
      color: theme.palette.grey[800],
    },
    '&.Mui-disabled': {
      opacity: 0.6,
    },
  }),
);
